module.exports = __webpack_public_path__ + "static/media/window-alt.6a39a20c.svg";